<div class="apply-one-style apply-one-grid" [attr.data-e2e]="e2e">
  <!-- seo zone -->
  <div
    class="site-width background-position-center background-size-cover"
    [style.background]="'url(' + backgroundImageUrl + ')'"
    [style.height]="backgroundImageStyleHeight"
  >
    <div class="container-fluid py-2">
      <h1 class="text-mw my-1 my-md-2" [attr.data-e2e]="e2e + '-title'">{{ title }}</h1>

      <!-- seo description -->
      <ng-container *ngIf="description">
        <p
          *ngFor="let item of stringArrayFormatter(description); let last = last"
          class="standard text-mw"
          [ngClass]="{'mb-0': !last}"
        >
          {{ item }}
        </p>
      </ng-container>

      <p class="text-center text-md-left d-flex justify-content-around d-md-block justify-content-md-left">
        <button class="btn btn-primary" (click)="emitLoginEvent()" [attr.data-e2e]="e2e + '-login'">
          {{ confirmationLabel || (i18nPath + '.authentication.label' | translate) }}
        </button>
      </p>

      <!-- find identifier link -->
      <p
        *ngIf="isIdentifierLinkDisplayed"
        class="text-center text-md-left d-flex justify-content-around d-md-block justify-content-md-left"
      >
        <a
          [href]="i18nPath + '.identifier.references.0.linkWeb.browser' | translate"
          class="o-link-arrow"
          target="_blank"
          (click)="emitFindIdentifierEvent()"
          [attr.data-e2e]="e2e + '-find-identifier'"
        >
          {{ i18nPath + '.identifier.label' | translate }}
          <span class="sr-only">{{i18nPath + '.identifier.label' | translate}}</span>
        </a>
      </p>
    </div>
  </div>

  <!-- reasons zone -->
  <div *ngIf="reasonTitle || reasons" class="bg-dark text-white site-width">
    <div class="container-fluid py-1 py-md-3">
      <h2 *ngIf="reasonTitle" class="no-signature mb-0 mb-md-2">{{ reasonTitle }}</h2>

      <p *ngIf="reasonSubTitle" class="lead mb-0 text-mw">
        <strong> {{ reasonSubTitle }} </strong>
      </p>

      <ul *ngIf="reasons" class="list">
        <li *ngFor="let reason of reasons; let last = last" class="text-white text-mw">{{ reason }}</li>
      </ul>

      <p *ngIf="reasonInformation" class="standard text-mw">{{ reasonInformation }}</p>
    </div>
  </div>

  <!-- widgets zone -->
  <div *ngIf="widgetTitle || widgets" class="site-width">
    <div class="container-fluid py-2 py-md-3">
      <h3
        *ngIf="widgetTitle"
        class="h4 text-mw text-md-center text-left mx-auto px-md-3"
        [ngClass]="{'mb-0' : widgetInformation}"
      >
        {{ widgetTitle }}
      </h3>

      <div *ngIf="widgetInformation" class="d-flex">
        <p class="standard text-mw mx-auto px-md-3 py-0 mb-2 mb-md-3">{{ widgetInformation }}</p>
      </div>
      <div *ngIf="widgets" class="row">
        <div
          *ngFor="let widget of widgets; let widgetIndex = index"
          class="col-12"
          [ngClass]="{'col-md-6': widgets.length === 2, 'col-md-4': widgets.length >= 3, 'mt-md-2': widgetIndex >= 3}"
        >
          <!-- div is used to align image box shadow with grid -->
          <div class="pr-1 mb-2">
            <img
              [src]="widget.picture"
              [alt]="widget.alt || ''"
              [attr.data-e2e]="e2e + '-widget-image-' + widgetIndex"
              class="img-fluid img-shadow"
              aria-hidden="true"
            />
          </div>

          <h4 class="lead mb-0">
            <strong> {{ widget.title }} </strong>
          </h4>

          <p class="standard m-0 mb-2 mb-md-0" [innerHTML]="widget.description"></p>
        </div>
      </div>
    </div>
  </div>
</div>
